(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 81980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
// EXTERNAL MODULE: ./node_modules/gsap/gsap-core.js
var gsap_core = __webpack_require__(25317);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(56546);
// EXTERNAL MODULE: ./helpers/index.js + 6 modules
var helpers = __webpack_require__(69494);
// EXTERNAL MODULE: ./context/index.js + 6 modules
var context = __webpack_require__(64167);
// EXTERNAL MODULE: ./components/common/index.js + 82 modules
var common = __webpack_require__(35135);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./styles/pages/ContactStyle.js

var ContactStyle = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
  className: 'contact'
}).withConfig({
  componentId: "c56sub-0"
})(["--imgSize:var(--sp81x);.contact-page{&-block{display:flex;flex-direction:column;.top-section{display:flex;justify-content:space-between;.title{max-width:var(--sp81x);width:100%;}.description{max-width:var(--sp98x);width:100%;margin-left:var(--sp21x);}}.main-section{display:flex;align-items:center;justify-content:space-between;margin-top:var(--pageFromHeaderMargin);position:relative;&:after{content:'';position:absolute;top:0;bottom:0;left:0;width:calc(var(--imgSize) / 2);background-color:var(--white);}.img{position:relative;z-index:1;max-width:var(--imgSize);width:40.25%;border-radius:50%;overflow:hidden;transform:scale(0);.imageCont{width:100%;padding-top:100%;transform:scale(3);> *{top:-10% !important;left:-10% !important;height:120%;width:120%;}}}.info{display:flex;justify-content:space-between;margin-left:var(--sp21x);max-width:var(--sp98x);width:100%;flex:1;.content{max-width:var(--sp60x);width:100%;display:flex;flex-direction:column;.single-info{display:flex;flex-direction:column;transform:translateX(-90vw);&:last-child{margin-top:var(--sp19x);}.title{margin-bottom:var(--titleFromContent);}}}.social{display:flex;flex-direction:column;transform:translateX(-90vw);a{&:not(:last-child){margin-bottom:var(--sp5x);}i{font-size:var(--sp10x);}}}}}}}@media screen and (max-width:", ") and (min-width:", "){--imgSize:var(--sp72x);.contact-page{&-block{.top-section{.title{max-width:var(--sp68x);}.description{max-width:var(--sp83x);margin-left:var(--sp18x);}}.main-section{.img{width:42.5%;}.info{margin-left:var(--sp15x);max-width:var(--sp83x);.content{max-width:var(--sp50x);.single-info{&:last-child{margin-top:var(--sp11x);}}}.social{a{&:not(:last-child){margin-bottom:var(--sp4x);}i{font-size:var(--sp7x);}}}}}}}}@media screen and (max-width:", ") and (min-width:", "){--imgSize:var(--sp68x);.contact-page{&-block{max-width:1130px;.top-section{.title{max-width:var(--sp68x);}.description{max-width:var(--sp68x);margin-left:var(--sp4x);}}.main-section{.img{width:48.45%;}.info{margin-left:var(--sp4x);max-width:var(--sp68x);.content{max-width:352px;.single-info{&:last-child{margin-top:var(--sp13x);}}}.social{a{&:not(:last-child){margin-bottom:var(--sp3x);}i{font-size:var(--sp5x);}}}}}}}}@media screen and (max-width:", ") and (min-width:", "){--imgSize:var(--sp57x);.contact-page{&-block{.top-section{flex-direction:column;.title{max-width:unset;margin-bottom:var(--sp2-5x);}.description{max-width:unset;margin-left:0;}}.main-section{.img{@media screen and (max-width:", "){max-width:var(--sp42x);}width:48.45%;}.info{margin-left:var(--sp3x);max-width:var(--sp68-5x);flex:1;.content{max-width:var(--sp44x);.single-info{&:last-child{margin-top:var(--sp13x);@media screen and (max-width:", "){margin-top:var(--sp9x);}}}}.social{a{&:not(:last-child){margin-bottom:var(--sp3x);}i{font-size:var(--sp7x);}}}}}}}}@media screen and (max-width:", "){--imgSize:unset;.contact-page{&-block{.top-section{flex-direction:column;.title{max-width:unset;margin-bottom:var(--sp3x);}.description{max-width:unset;margin-left:0;}}.main-section{flex-direction:column;margin-top:var(--sp3x);.img{max-width:unset;width:100%;margin-bottom:var(--sp3x);}.info{margin-left:0;max-width:unset;flex:1;.content{max-width:var(--sp31x);.single-info{&:last-child{margin-top:var(--sp10x);}}}.social{a{&:not(:last-child){margin-bottom:var(--sp2x);}i{font-size:var(--sp7x);}}}}}}}}"], function (props) {
  return props.theme.mediaQuery.DesktopSizeLMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeM;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeMMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeS;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeSMin;
}, function (props) {
  return props.theme.mediaQuery.TabletSize;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.TabletSizeMin;
});
/* harmony default export */ var pages_ContactStyle = (ContactStyle);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/contact-us/index.js

var _excluded = ["pages", "pageParams", "selectedLang", "preloader"];



gsap/* gsap.registerPlugin */.p8.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap/* gsap.core.globals */.p8.core.globals('ScrollTrigger', ScrollTrigger.ScrollTrigger);
 //* HOC's

 //* Components

 //* Styles




var ContactUs = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var _pageData$content, _pageData$content$met, _pageData$content2, _pageData$content3;

  var pages = _ref.pages,
      pageParams = _ref.pageParams,
      selectedLang = _ref.selectedLang,
      preloader = _ref.preloader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  //! Page Data
  var pageData = (0,react.useMemo)(function () {
    var _pages$pageParams$nam;

    return pages === null || pages === void 0 ? void 0 : (_pages$pageParams$nam = pages[pageParams.name]) === null || _pages$pageParams$nam === void 0 ? void 0 : _pages$pageParams$nam[selectedLang];
  }, [pages, selectedLang, pageParams.name]); //! State

  var _useState = (0,react.useState)(),
      secObj = _useState[0],
      setSecObj = _useState[1];

  var _useState2 = (0,react.useState)(),
      otherItem = _useState2[0],
      setOtherItem = _useState2[1]; //! ref


  var titleRef = (0,react.useRef)();
  var descriptionRef = (0,react.useRef)();
  var Ref2 = (0,react.useRef)();
  var Ref3 = (0,react.useRef)();
  var Ref4 = (0,react.useRef)();
  var mouseOver = (0,react.useCallback)(function (e) {
    if (props.winWidth >= 1024 && e.clientX) {
      var diffX = e.clientX - props.winWidth / 2;
      var diffY = e.clientY - props.winHeight / 2;
      gsap_core/* TweenLite.to */.iC.to(Ref2.current.firstChild.firstChild, {
        x: diffX / -15,
        y: diffY / -15
      });
    }
  }, [props.winWidth, props.winHeight]);
  var mouseOut = (0,react.useCallback)(function () {
    if (props.winWidth >= 1024) {
      gsap_core/* TweenLite.to */.iC.to(Ref2.current.firstChild.firstChild, 0.5, {
        y: 0,
        x: 0
      });
    }
  }, []);
  var config = [{
    scale: 1,
    ease: 'power1.out',
    duration: 0.9
  }, {
    x: 0,
    stagger: 0.05,
    delay: 0.4,
    ease: 'power1.out',
    duration: 0.8
  }];
  (0,react.useEffect)(function () {
    if (pageData && titleRef !== null && titleRef !== void 0 && titleRef.current && descriptionRef !== null && descriptionRef !== void 0 && descriptionRef.current && !preloader) {
      setOtherItem([[Ref2.current, Ref2.current.firstChild], [Ref3.current.childNodes, Ref4.current]]);
      setSecObj([(0,helpers/* arrayGenChild */.YJ)(titleRef.current.childNodes[0].childNodes), descriptionRef.current]);
    }
  }, [titleRef.current, descriptionRef.current, Ref2.current, Ref3.current, Ref4.current, pageData, preloader]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(pages_ContactStyle, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Page */.T3, {
      className: "contact-page",
      meta: {
        title: pageData === null || pageData === void 0 ? void 0 : (_pageData$content = pageData.content) === null || _pageData$content === void 0 ? void 0 : (_pageData$content$met = _pageData$content.meta) === null || _pageData$content$met === void 0 ? void 0 : _pageData$content$met.title,
        description: pageData === null || pageData === void 0 ? void 0 : (_pageData$content2 = pageData.content) === null || _pageData$content2 === void 0 ? void 0 : _pageData$content2.meta.description,
        keywords: pageData === null || pageData === void 0 ? void 0 : (_pageData$content3 = pageData.content) === null || _pageData$content3 === void 0 ? void 0 : _pageData$content3.meta.keywords,
        image: pageData === null || pageData === void 0 ? void 0 : pageData.content.meta_image
      },
      children: pageData && /*#__PURE__*/(0,jsx_runtime.jsx)(common/* AnimationWrapp */.dh, {
        state: secObj,
        otherItem: otherItem,
        afterComplete: config,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(common/* Container */.W2, {
          className: "contact-page-block last",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "top-section",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
              tag: 'stringToLetters',
              className: 'h1 title MonBold black',
              text: pageData === null || pageData === void 0 ? void 0 : pageData.content.title,
              ref: titleRef
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
              tag: 'h6',
              className: 'description h6 MonRegular black',
              text: pageData === null || pageData === void 0 ? void 0 : pageData.content.text,
              ref: descriptionRef
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "main-section overflowHidden",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "img",
              ref: Ref2,
              onMouseMove: function onMouseMove(e) {
                return mouseOver(e);
              },
              onMouseLeave: function onMouseLeave(e) {
                return mouseOut(e);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Image */.Ee, {
                src: pageData === null || pageData === void 0 ? void 0 : pageData.content.image,
                alt: pageData === null || pageData === void 0 ? void 0 : pageData.content.title
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "info",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "content",
                ref: Ref3,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "single-info",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
                    tag: 'h5',
                    className: 'title uppercase h5 MonRegular black',
                    text: 'contactUsText'
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
                    tag: 'h3',
                    className: 'h3 MonMedium black',
                    text: pageData === null || pageData === void 0 ? void 0 : pageData.content.email
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "single-info",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
                    tag: 'h5',
                    className: 'title uppercase h5 MonRegular black',
                    text: 'addressText'
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
                    tag: 'h3',
                    className: 'h3 MonMedium black',
                    text: pageData === null || pageData === void 0 ? void 0 : pageData.content.address
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "social",
                ref: Ref4,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  target: "_blank",
                  href: pageData === null || pageData === void 0 ? void 0 : pageData.content.socials.facebook,
                  rel: "noopener noreferrer",
                  "aria-label": "facebook",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Icon */.JO, {
                    className: "icon-facebook"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  target: "_blank",
                  href: pageData === null || pageData === void 0 ? void 0 : pageData.content.socials.linkedin,
                  rel: "noopener noreferrer",
                  "aria-label": "linkedin",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Icon */.JO, {
                    className: "icon-linkedin"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  target: "_blank",
                  href: pageData === null || pageData === void 0 ? void 0 : pageData.content.socials.twitter,
                  rel: "noopener noreferrer",
                  "aria-label": "twitter",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Icon */.JO, {
                    className: "icon-twitter"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  target: "_blank",
                  href: pageData === null || pageData === void 0 ? void 0 : pageData.content.socials.telegram,
                  rel: "noopener noreferrer",
                  "aria-label": "telegram",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Icon */.JO, {
                    className: "icon-telegram"
                  })
                })]
              })]
            })]
          })]
        })
      })
    })
  });
});
/* harmony default export */ var contact_us = ((0,context/* withLanguageContext */.VZ)((0,context/* withUIContext */.pP)((0,context/* withDataContext */.hX)(ContactUs, ['pages']), ['screenSizes', 'winWidth', 'winHeight']), ['selectedLang']));

/***/ }),

/***/ 58157:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(81980);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(58157); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);